import dialog from "@/lib/easy-dialog"
import { loadJs } from "@/lib/loadJs";
import { onceOptions } from "@/lib/onceOptions";

const ShowDialogForSubscribe = (title: string, contentInfo: string) => {
  dialog.open({
    container: {
      header: title,
      content: '<span class="Font_15">' + contentInfo.replace(new RegExp('\\n', 'g'), '<br/>') + '</span>',
      yesFn: dialog.close,
      yesText: '<span class="Font_15">OK</span>'
    },
    fixed: true,
    drag: false
  });
}

const OpenThirdPartyResubscribeForm = (url: string) => {
  dialog.open({
    container: {
      header: 'Resubscribe Email',
      content: '<iframe id="iframe" src="' + url + '" frameborder="0" style="width:520px; max-width:100%; height:180px;" scrolling="no" ></iframe>',
    },
    fixed: true,
    drag: false
  });
}

const ajaxprocess = (result: string, email: string) => {
  if (result === 'unsubscribed') { // 已取消订阅--弹出Resubscribe Form
    var resubscribeUrl = "/ThirdPartySubscribe/ResubscribeEmail.aspx?email=" + encodeURIComponent(email);
    OpenThirdPartyResubscribeForm(resubscribeUrl);
  }
  else if (result === 'subscribed') { // 已订阅
    ShowDialogForSubscribe("Subscribe Info", "<font size=\"4\">Looks like you are already subscribed!</font><br /><br />Please, add <span style=\"text-decoration: underline;\">info@anypromo.ca</span> to your address book to ensure delivery.");
  }
  else if (result === 'ok') { // 首次订阅
    ShowDialogForSubscribe("Subscribe Info", "<font size=\"4\">Thank you for subscribing.</font><br /><br />Please, add <span style=\"text-decoration: underline;\">info@anypromo.ca</span> to your address book to ensure delivery.");
  }
  else if (result === 'Please input first Name.') {
    $("#txtFname").val('');
    ShowDialogForSubscribe("Subscribe Info", result);
  }
  else if (result === 'Please input last Name.') {
    $("#txtLname").val('');
    ShowDialogForSubscribe("Subscribe Info", result);
  }
  else if (result !== undefined) {
    ShowDialogForSubscribe("Subscribe Info", result);
  }
}

const ThirdPartySubscribe = (email: string, source: string, code?: string) => {
  const data = {
    "email": email,
    "source": source,
    "code": code ?? '',
    "UserAgent": window.navigator.userAgent
  };
  fetch('/EDM/Subscribe_Attached.aspx/Subscribe', {
    method: 'POST', // 请求方法
    headers: {
      'Content-Type': 'application/json', // 指定发送的数据格式为 JSON
    },
    body: JSON.stringify(data) // 将数据转换为 JSON 字符串发送
  }).then(r => {
    if (!r.ok) {
      const error = new Error(r.statusText);
      //@ts-ignore
      error.response = r;
      throw error;
    } else {
      return r.json()
    }
  }).then(r => {
    const { d } = r;
    //成功回调函数
    window.robotVerified = function (response: any) {
      ThirdPartySubscribe(email, source, response);
    };

    if (d.indexOf('recaptcha') == 0) {
      loadJs("//www.google.com/recaptcha/api.js")
      const arr = d.split("_|_");
      //弹出验证码提示框
      const str = `<div class="subscribe-form">
<dl>
 <dt>Your email: </dt>
 <dd>${email}</dd>
</dl>
<div class="recaptcha">
 <div id="J-recaptcha" class="g-recaptcha" data-callback="robotVerified" data-sitekey="${arr[1]}"></div>
</div>
</div>`;
      dialog.open({
        container: {
          header: 'Confirmation',
          content: str,
          cusTextClass: ' subscribe-dialog'
        },
        fixed: true,
        drag: false
      });
    } else {
      ajaxprocess(d, email);
    }

  }).catch(error => {
    console.log('request failed', error);
  })
}

export const initSubscribe = () => {
  const btn = document.getElementById("footer_emailbutton");
  const txtFooterEmail = document.getElementById("txtFooterEmail") as HTMLInputElement;
  if (btn != null) {
    btn.addEventListener("click", () => {

      const value = txtFooterEmail!.value.trim()
      if (value.length == 0) {

        // Usage
        dialog.open({
          container: {
            header: "Subscribe Info",
            content: "Please input your email address.",
            yesFn () {
              dialog.close()
            },
          },
          overlay: true,
        });
      } else {
        ThirdPartySubscribe(value, 'footer');
      }

    })
  }

  txtFooterEmail!.addEventListener("focus", () => {
    // loadCSS('/assets/css/footer-email.css')


  }, onceOptions)
}